import {createRouter, createWebHistory} from 'vue-router'
import routes from "@/router/routes";

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta?.authRedirectTimetable) {
    return {
      name: localStorage.getItem('token') ? 'timetable' : 'setup',
      query: { redirect: to.fullPath },
    }
  }

  if (to.name === 'general-testing-access' && localStorage.getItem('token')) {
    return {
      name: 'general-testing',
    }
  }

  if (to.meta.requiresAuth && !localStorage.getItem('token')) {
    return {
      name: 'auth',
      query: { redirect: to.fullPath },
    }
  }
})

export default router
